/* eslint-disable no-unused-vars */
import React, { useCallback, useState } from 'react';
import { ConfirmationResult, UserCredential } from 'firebase/auth';
import FormInput from '../../Components/Ui/FormInput';
import FormCheckbox from '../../Components/FormFields/FormCheckbox';
import Code from '../../Components/Auth/Code';
import { validatePhoneNumber } from '../../Validation/Phone';
import { loginWithPhoneNumber } from '../../Services/FirebaseService';
import Functions from '../../Helpers/Functions';
import DialogLayout from '../../Components/DialogLayout';
import Client from '../../Objects/models/Client';
import Teachr from '../../Objects/models/Teachr';
import { persistanceConnexion } from './useAuthFn';

interface PhoneDialogProps {
  handleSetAndRedirectUserConnect: (userCredential: UserCredential, authMethod: any, userObject?: Teachr | Client, isTeachr?: boolean) => void;
  loading: boolean;
}

const usePhoneDialog = (props: PhoneDialogProps) => {
  const [phoneDialogOpen, setPhoneDialogOpen] = useState(false);
  const [codeDialogOpen, setCodeDialogOpen] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
    const [userNotFound, setUserNotFound] = useState(false);
  const [tel, setTel] = useState('');
  const [remember, setRemember] = useState(false);
  const [confirmationResult, setConfirmationResult] = useState<ConfirmationResult | null>(null);
  const [sendCodeLoading, setSendCodeLoading] = useState(false);
  const [phoneError, setPhoneError] = useState('');

  const handleCancel = () => {
    setCodeDialogOpen(false);
    setUserNotFound(false);
    setResendLoading(false);
    // setIsPinCodeValid(false);
  }

  const showPhoneLoginWidget = () => setPhoneDialogOpen(true);

  const handleSendCode = useCallback(() => {
    const error = validatePhoneNumber(tel);
    if (error) {
      setPhoneError(error);
      return;
    }
    setSendCodeLoading(true);
    persistanceConnexion(remember, () => {
      loginWithPhoneNumber(Functions.formatPhoneNumber(tel))
        .then((response) => {
          setConfirmationResult(response);
          setPhoneDialogOpen(false);
          setCodeDialogOpen(true);
          setTel("");
          setPhoneError('');
        })
        .catch(() => {
          setTel("");
          setPhoneError(
            `Nous rencontrons actuellement un problème technique. Veuillez réessayer plus tard ou nous contacter par mail à l'adresse ${process.env.REACT_APP_MAIL_SUPPORT}`
          );
        })
        .finally(() => setSendCodeLoading(false));
    });
  }, [remember, tel]);

  const phoneDialogNode = (
    <>
      <DialogLayout
        open={phoneDialogOpen}
        title="Connexion via SMS"
        valid="Envoyer le code de vérification"
        cancel="Annuler"
        handleClose={() => setPhoneDialogOpen(false)}
        handleCloseIcon={() => setPhoneDialogOpen(false)}
        handleSubmit={handleSendCode}
        load={sendCodeLoading}
      >
        <div className="flex flex-col gap-4">
          <FormInput
            label="Téléphone"
            name="phone"
            type="tel"
            placeholder="06 XX XX XX XX"
            value={tel}
            error={phoneError}
            onChange={(e) => {
              setTel(e.target.value);
              setPhoneError('');
            }}
            required
          />
          <FormCheckbox
            label="Se souvenir de moi"
            checked={remember}
            onChange={() => setRemember((prev) => !prev)}
            required={false}
          />
        </div>
      </DialogLayout>
      {confirmationResult && (
        <DialogLayout
          open={codeDialogOpen}
          title="Connexion via SMS"
          handleClose={() => handleCancel()}
          handleCloseIcon={() => handleCancel()}
          customDialogActions="none"
        >
          <Code
            phone={tel}
            code={confirmationResult}
            handleSetAndRedirectUserConnect={props.handleSetAndRedirectUserConnect}
            setCodeDialogOpen={setCodeDialogOpen}
            setUserNotFound={setUserNotFound}
            setResendLoading={setResendLoading}
            userNotFound={userNotFound}
            resendLoading={resendLoading}
            handleCancel={handleCancel}
          />
        </DialogLayout>
      )}
    </>
  );

  return { showPhoneLoginWidget, phoneDialogNode };
};

export default usePhoneDialog;
